export const mediaItems = [
  {
    id: 1,
    type: 'image',
    src: '/media001/j_endyyy_extreme_minimalism_fine_art_photograph_single_pure_w_180d935a-1a59-4b2d-8a53-5436fee2fd4f_0.png',
    width: 1280,
    height: 720,
    title: 'Pure Minimalism',
    medium: 'Fine Art Photography',
    year: '2024',
    collection: 'Minimalist Series',
    style: 'Minimalism',
    description: 'An exploration of extreme minimalism through pure white forms and negative space.',
    inspiration: 'Inspired by the concept of void and presence, this piece explores how absence can be as powerful as presence in visual storytelling.',
    process: [
      'Conceptualized the relationship between positive and negative space',
      'Set up controlled lighting to eliminate all distractions',
      'Captured multiple exposures to achieve perfect white balance',
      'Post-processed to enhance the minimalist aesthetic'
    ]
  },
  {
    id: 2,
    type: 'image',
    src: '/media001/j_endyyy_Abstract_photography_Zastava_TT_Pistol_in_a_modern_t_afc3ac4e-a985-4d66-8a44-019e80d997d5_1.png',
    width: 1920,
    height: 1080,
    title: 'Modern Geometry',
    medium: 'Abstract Photography',
    year: '2024',
    collection: 'Industrial Forms',
    style: 'Abstract',
    description: 'Contemporary forms meet industrial design in this study of modern aesthetics.',
    inspiration: 'The intersection of function and form in industrial design, exploring how utilitarian objects can become art through perspective.',
    process: [
      'Studied the geometric properties of industrial objects',
      'Experimented with lighting angles to emphasize form',
      'Composed the shot to highlight abstract qualities',
      'Applied selective color grading to enhance the modern aesthetic'
    ]
  },
  {
    id: 3,
    type: 'video',
    src: '/media001/Gen-3%20Alpha%202443414284,%20Make%20the%20mountai.mp4',
    width: 1920,
    height: 1080,
    title: 'Mountain Motion',
    medium: 'Digital Video',
    year: '2024',
    collection: 'Nature Studies',
    style: 'Cinematic',
    description: 'A dynamic exploration of natural landscapes through motion.',
    inspiration: 'The ever-changing nature of landscapes and how movement can reveal hidden beauty in static environments.'
  },
  {
    id: 4,
    type: 'image',
    src: '/media001/j_endyyy_An_elegant_and_precise_visualization_of_the_Accuracy_0ee0bcac-6ed2-4b23-befa-6804c246d20e_0.png',
    width: 1920,
    height: 1080,
    title: 'Precision Study',
    medium: 'Digital Art',
    year: '2024',
    collection: 'Technical Series',
    style: 'Technical',
    description: 'An elegant visualization exploring concepts of accuracy and precision.',
    inspiration: 'The beauty found in technical precision and the aesthetic qualities of measurement and accuracy.'
  },
  {
    id: 5,
    type: 'video',
    src: '/media001/j_endyyy_architectural_light_panels_on_the_left_casting_soft__3a9edef3-05c7-4500-8ae6-d28a2a4928c9_2.mp4',
    width: 1920,
    height: 1080,
  },
  {
    id: 6,
    type: 'video',
    src: '/media001/j_endyyy_floating_in_a_black_void_soft_downward_motion_gentle_ab8546c8-8586-4cab-8a0a-6f04ea59b1cf_1.mp4',
    width: 1920,
    height: 1080,
  },
  {
    id: 7,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.run2bZumd6nAlM_A_sophisticated_premium_car_b295695f-1c1e-405a-8a03-34557aaf4c0f_3.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 8,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.run2bZumd6nAlM_httpss.mj.runsC9XmzFlJy0_Abst_1ee1bab4-5218-4e89-86c4-511bee082fbf.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 9,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.run2bZumd6nAlM_httpss.mj.runsC9XmzFlJy0_ht_26188eab-574e-45c6-8194-05e66803416b_0.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 10,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.run2bZumd6nAlM_httpss.mj.runsC9XmzFlJy0_ht_5016104f-883c-4d85-bcd3-f0b6d993cb0e_0.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 11,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.run2bZumd6nAlM_httpss.mj.runsC9XmzFlJy0_ht_b70b29b2-e6cd-412b-89fc-6a86c89742b1_1.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 12,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.run2bZumd6nAlM_httpss.mj.runsC9XmzFlJy0_http_627ffa7a-5a94-44bd-871a-c654ca4f40b8.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 13,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.run2bZumd6nAlM_httpss.mj.runsC9XmzFlJy0_http_f55f2405-6c6d-4c90-87a4-84038167fcb6.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 14,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.run7Bl1V5dq2uo_hyper-realistic_macro_photogr_255cb696-6560-4e3c-b5dc-9387c61e695d%20(1).png',
    width: 1920,
    height: 1080,
  },
  {
    id: 15,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runOwjBGdshQac_httpss.mj.runKVrvCVKM3gU_ht_7784ee71-f8db-4b9a-ab1a-9e00fcd2d458_0.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 16,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.rune-8Z6N1g6rU_httpss.mj.runeiJSNw4CXEU_http_8b5dac44-d8e3-448d-9e1d-2093e3d3971f%20(1).png',
    width: 1920,
    height: 1080,
  },
  {
    id: 17,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runeiJSNw4CXEU_httpss.mj.run2bZumd6nAlM_Ab_3bac54d0-d9b0-4e3a-879f-4ba7acacd137_3.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 18,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runeiJSNw4CXEU_httpss.mj.run2bZumd6nAlM_Ab_d84fd80c-b143-45dd-a462-9e2bef8d0f36_1.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 19,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runjhmz2hCRLfA_httpss.mj.runguMVvKWB_yo_ht_218e4e79-f377-4934-8fda-6cd8eb925ce9_0.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 20,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runjhmz2hCRLfA_httpss.mj.runguMVvKWB_yo_ht_53f31c3c-bc88-4c81-aaf3-a551cce0c24a_1.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 21,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runpgOQ_x98_BQ_httpss.mj.runAxqxv-MT-60_a__5e844f22-265a-4e93-b1dc-126db35f6b5a_0.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 22,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runsC9XmzFlJy0_httpss.mj.run-1sSrBvelSs_ht_2c58e350-a56f-4dbb-965e-bf5412818f3c_3.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 23,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runsC9XmzFlJy0_httpss.mj.run-1sSrBvelSs_ht_4224800b-e116-4e80-bc64-b5dd5b6246ad_3.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 24,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runsC9XmzFlJy0_httpss.mj.run-1sSrBvelSs_ht_74d0df6c-29a8-474b-bfd0-99bfe7e16467_1.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 25,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runsC9XmzFlJy0_httpss.mj.runKVrvCVKM3gU_Mi_7186798b-10c0-4250-90f5-28897e3552cb_3.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 26,
    type: 'image',
    src: '/media001/j_endyyy_httpss.mj.runuE93Oj6lqgc_a_single_mechanical_object_su_ba03df93-382a-4d64-900d-c7012d7fb838.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 27,
    type: 'image',
    src: '/media001/j_endyyy_tight_macro_shot_of_womans_red_glossy_lips_mid-bite__f0c8cc66-a10d-4f2f-a2c3-5ae15bde622f_1.png',
    width: 1920,
    height: 1080,
  },
  {
    id: 28,
    type: 'video',
    src: '/media001/Gen-3%20Alpha%20Turbo%20625943866,%20An%20extreme%20wide%20angl,%20j_endyyy_httpssmjr,%20M%205.mp4',
    width: 1920,
    height: 1080,
  },
  {
    id: 29,
    type: 'video',
    src: '/media001/dsturbd_weird_close-ups_by_Martin_parr_--ar_5877_--motion_hig_c64bc358-ae52-4cea-8a06-2e985515919c_0.mp4',
    width: 1920,
    height: 1080,
  },
  {
    id: 30,
    type: 'video',
    src: '/media001/rebecca_sanders_art_surreal_photography_by_Sarah_Moon.The_pho_6194ae00-b472-428b-b8af-126416c32110_0.mp4',
    width: 1920,
    height: 1080,
  },
  {
    id: 31,
    type: 'video',
    src: '/media001/social_j_endyyy_floating_in_a_black_void_soft_downward_motion_gentle_ab8546c8-8586-4cab-8a0a-6f04ea59b1cf_1%20(1).mp4',
    width: 1920,
    height: 1080,
  },
];